import { render } from "./BagReassurances.vue?vue&type=template&id=764b733c&scoped=true"
import script from "./BagReassurances.vue?vue&type=script&lang=js"
export * from "./BagReassurances.vue?vue&type=script&lang=js"

import "./BagReassurances.vue?vue&type=style&index=0&id=764b733c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764b733c"]])

export default __exports__